import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";



function AddCategoryScheduleForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState();
  const [formData, setFormData] = useState({
    category_id: "",
    category: "",
    start_time: "",
    end_time: "",
    status: "active",
    user_id: user.user.id,
    outlet_id: user.user.outlet_id,
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (e) => {
    setFormData({
      ...formData,
      [e.name]: e.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!id) {
      axios
        .post(`${apiKey}/api/rms/admin/categories/schedule`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          toast.error(err.response.data.details, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      axios
        .post(`${apiKey}/api/rms/admin/categories/schedule/${id}?_method=PUT`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          toast.error(err.response.data.details, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    const fetchCategories = () => {
      return axios.get(`${apiKey}/api/rms/admin/categories`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchData = () => {
      Promise.all([fetchCategories()])
        .then(([dataRes]) => {
          const mappedCategories = dataRes.data.map((item) => ({
            label: item.category_name,
            value: item.id,
            // price: item.sale_price,
            name: "category_id",
          }));
          setData(mappedCategories);
        })
        .catch((err) => {
          setError(err);
        });
    };

    handleCSRF(fetchData);

    if (id) {
      setPageLoading(true);
      const fetchDiscount = () => {
        axios
          .get(`${apiKey}/api/rms/admin/categories/schedule/${id}`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
            params: {
              includes: "category",
            },
          })
          .then((res) => {
            setFormData(res.data.data);
          })
          .catch((err) => {
            setError(err.response.data.message);
          })
          .finally(() => {
            setPageLoading(false);
          });
      };

      handleCSRF(fetchDiscount);
    }
  }, [id, user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">{languageHelper("Add Category Schedule")}</h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-x-8 gap-y-2 w-full">
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Category Name")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    placeholder="Select"
                    options={data}
                    defaultValue={{
                      value: formData.category?.id,
                      label: formData.category?.category_name,
                    }}
                    onChange={handleSelectChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Start Time")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="time"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder=""
                    value={formData.start_time}
                    name="start_time"
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  font-bold">
                  {languageHelper("End Time")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="time"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder=""
                    name="end_time"
                    value={formData.end_time}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <div className="form-check text-d-bg-text">
                  <div>
                    <h2>{languageHelper("Status")}</h2>
                  </div>
                  <input
                    type="radio"
                    name="status"
                    id="is_offer_yes"
                    value="active"
                    defaultChecked={formData.status === "active"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "one_time"
                      });
                    }}
                  />
                  <label
                    className="form-check-label pe-5 ps-3"
                    htmlFor="is_offer_yes"
                  >
                    {languageHelper("Active")}
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="status"
                    id="is_offer_no"
                    value="inactive"
                    defaultChecked={formData.status === "inactive"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "regular"
                      });
                    }}
                  />
                  <label
                    className="form-check-label ps-3"
                    htmlFor="is_offer_no"
                  >
                    {languageHelper("Inactive")}
                  </label>
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddCategoryScheduleForm;
